import { constant } from "node_modules/cypress/types/lodash";
import { CreateEventButton } from "../CreateEventModal";
import Link from "next/link";
import {
    GetCommunitiesToHost,
    GetCurrentUserProfile,
} from "~/app/beta/events/create/actions";
import HomePeopleIcon from "../icons/HomePeopleIcon";
import SharedHomeHeader from "./SharedHomeHeader";

type Props = {
    user: GetCurrentUserProfile;
    communities: GetCommunitiesToHost;
};

const PeopleHeader = ({ user, communities }: Props) => {
    const title = "Meet like-minded people and grow your network";
    const smallTitle = "Meet like-minded people";
    const subTitle = (
        <>
            Host for your followers, see where your connections are going, and
            connect with mutuals.
        </>
    );
    const smallSubTitle = "Connect with your followers and mutuals.";
    const actionsBar = (
        <>
            <CreateEventButton
                variant="default"
                user={user}
                communities={communities}
                size="sm"
            />

            <Link
                href="https://app.getriver.io/river"
                target="_blank"
                className="text-sm hover:underline"
            >
                Get a live demo
            </Link>
        </>
    );
    const mobileActionsBar = (
        <div className="flex w-full flex-col gap-2">
            <CreateEventButton
                variant="default"
                user={user}
                communities={communities}
                size="sm"
                className="w-full"
            />
            <div className="flex w-full justify-between">
                <Link
                    href="https://app.getriver.io/river"
                    target="_blank"
                    className="text-sm hover:underline"
                >
                    Get a live demo
                </Link>
            </div>
        </div>
    );
    const squareIcon = <HomePeopleIcon className="h-[72px] w-[72px]" />;

    return (
        <SharedHomeHeader
            title={title}
            smallTitle={smallTitle}
            subTitle={subTitle}
            smallSubTitle={smallSubTitle}
            actionsBar={actionsBar}
            mobileActionsBar={mobileActionsBar}
            squareColor="#F4F2E3"
            squareIcon={squareIcon}
        />
    );
};

export default PeopleHeader;
